module.exports = __webpack_public_path__ + "img/case3.1646a21a.png";